import Vue from "vue";
import { NotificationPermission } from "@tt-app/store/user/types";

enum SubscribedStatus {
  unknown = -2,
  denied,
  notDetermined,
  authorized
}

const OneSignalNativeWrapper = {
  nativeBinder: (window as any).OneSignal,

  deleteTags(tags: string[]) {
    this.nativeBinder.deleteTags(tags);
  },

  getNotificationPermission() {
    return new Promise(resolve => {
      const nativePromptShown = window.localStorage.getItem("nativePromptShown");

      if (!nativePromptShown) {
        resolve(NotificationPermission.DEFAULT);
      }

      this.nativeBinder.checkOSPushNotificationGrant((subscribed: SubscribedStatus) => {
        let status = undefined;

        switch (subscribed) {
          case SubscribedStatus.authorized:
            status = NotificationPermission.GRANTED;
            break;
          case SubscribedStatus.denied:
            status = NotificationPermission.DENIED;
            break;
          case SubscribedStatus.unknown:
          case SubscribedStatus.notDetermined:
          default:
            status = undefined;
            break;
        }

        resolve(status);
      });
    });
  },

  getTags() {
    return new Promise(resolve => {
      this.nativeBinder.getTags((tags: { [key: string]: string }) => {
        resolve(tags);
      });
    });
  },

  async init() {
    // initialization is handled in swift
  },

  isPushNotificationsEnabled() {
    return new Promise(resolve => {
      this.nativeBinder.checkOneSignalGrant((subscribed: boolean) => {
        resolve(subscribed);
      });
    });
  },

  off() {
    // native binding doesn't have `off` function
  },

  on() {
    // native binding doesn't have `on` function
  },

  removeExternalUserId() {
    return new Promise((resolve, reject) => {
      this.nativeBinder.removeExternalUserId(
        () => {
          resolve(true);
        },
        (error: any) => {
          reject(error);
        }
      );
    });
  },

  setExternalUserId(aliasUuid: string) {
    return new Promise((resolve, reject) => {
      this.nativeBinder.setExternalUserId(
        aliasUuid,
        undefined,
        () => {
          resolve(true);
        },
        (error: any) => {
          reject(error);
        }
      );
    });
  },

  setSubscription(receiveNotifications: boolean) {
    this.nativeBinder.disablePush(!receiveNotifications);
  },

  showNativePrompt() {
    return new Promise(resolve => {
      window.localStorage.setItem("nativePromptShown", "true");

      this.nativeBinder.requestPushNotificationPermission((granted: boolean) => {
        resolve(granted);
      });
    });
  }
};

const OneSignalNativePlugin = {
  install: function(app: typeof Vue) {
    app.prototype.$OneSignal = OneSignalNativeWrapper;
  }
};

export default OneSignalNativePlugin;
